import apiClient from "../../../api/apiClient";

//Base URL

const BASE_PATH = "admin/lagan";

export const getLaganList = async () => {
  const response = await apiClient.get(`${BASE_PATH}/`, {});
  return response.data;
};

export const createLagan = async (createLaganValues) => {
  const response = await apiClient.post(BASE_PATH + "/", createLaganValues);
  return response.data;
};

export const getLagan = async () => {
  const response = await apiClient.post(`${BASE_PATH}/get`, {});
  return response.data;
};

export const updateLagan = async (updateLaganValues) => {
  const response = await apiClient.put(`${BASE_PATH}/`, updateLaganValues);
  return response.data;
};
